import {Action} from "../../../action/action";
import type {CancelBookingAdminState} from "../cancelBookingAdminState";
import type {OnBehalfOf} from "../cancelBookingAdminState.types";

export const SET_CANCEL_ON_BEHALF_OF = "SET_CANCEL_ON_BEHALF_OF";
export class SetCancelOnBehalfOf extends Action<typeof SET_CANCEL_ON_BEHALF_OF, OnBehalfOf> {
  readonly type = SET_CANCEL_ON_BEHALF_OF;
  protected state: CancelBookingAdminState;

  constructor(state: CancelBookingAdminState, data?: OnBehalfOf) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    if (["Customer", "Partner"].includes(this.data)) return true;
    return false;
  }

  public isDoable(): boolean {
    return true;
  }
}
